/* Location Modal Component */
import React from 'react';
import { LOCATIONS, LOCATION_ICONS } from '../utils/constants';
import { ModalHeader, Modal, ModalBody, ModalFooter, Row, Col, Label, Input, Button } from "reactstrap";

import '../css/kiosk.css'; // Assuming you have a CSS file for styling
import 'bootstrap/dist/css/bootstrap.min.css';

interface LocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentLocation: string;
  onLocationChange: (location: string) => void;
}

const LocationModal = ({ isOpen, onClose, currentLocation, onLocationChange }:LocationModalProps) => {
  const [selectedLocation, setSelectedLocation] = React.useState(currentLocation);
  
  // Handle location selection
  const handleLocationSelect = (location:string) => {
    setSelectedLocation(location);
  };
  
  // Handle save button click
  const handleSave = () => {
    onLocationChange(selectedLocation);
    onClose();
  };
  
  if (!isOpen) return null;
  
  return (
    <Modal 
          title="Set iPad Location" 
          isOpen={isOpen} 
          onClose={() => {
            onClose();
            setSelectedLocation('');
          }}
        >
          <form onSubmit={handleSave}>
            <div className="modal-form-group">
              <label className="modal-label" htmlFor="location">Location</label>
              <select 
                id="location"
                className="modal-select"
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                required
              >
                <option value="">Select location</option>
                {["Detroit", "Birmingham", "Troy", "Madison Heights", "Shelby", "Ferndale", "Kentucky", "Portland"].map(loc => (
                  <option key={loc} value={loc}>
                    {LOCATION_ICONS[loc] ? `${LOCATION_ICONS[loc]} ${loc}` : loc}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="modal-buttons">
              <button 
                type="button" 
                className="modal-button modal-button-cancel"
                onClick={() => {
                  onClose();
                  setSelectedLocation('');
                }}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="modal-button modal-button-submit"
                disabled={!selectedLocation}
              >
                Save
              </button>
            </div>
          </form>
        </Modal>
      );
};

export default LocationModal;